import { Routes } from '../App';

export const isBrowser: boolean = typeof window !== 'undefined';

function detectBrowserByUserAgent(matchString: string): boolean {
  if (isBrowser) {
    try {
      return window.navigator.userAgent.includes(matchString);
    } catch (e) {
      console.error(e);
    }
  }
  return false;
}

/**
 * Check if Instagram webview browser
 */
export const isInstagram: boolean = detectBrowserByUserAgent('Instagram');

/**
 * Check if Facebook webview browser
 */
export const isFacebook: boolean =
  detectBrowserByUserAgent('FBAV') || detectBrowserByUserAgent('FBAN');

/**
 * Detects both Facebook & Instagram in-app browsers
 */
export const isMetaInAppBrowser: boolean = isFacebook || isInstagram;

/**
 * Detect user system
 */
export function getOS() {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  if (macosPlatforms.indexOf(platform) !== -1) {
    return 'mac';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    return 'ios';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    return 'windows';
  } else if (/Android/.test(userAgent)) {
    return 'android';
  } else if (/Linux/.test(platform)) {
    return 'linux';
  }
  return 'other';
}

export const redirectToNativeBrowser = (configParams: Record<string, any>): void => {
  const isRedirectAppRoute = [
    Routes.MAIN,
    Routes.COMPARISON_QUIZ,
    Routes.LOOKALIKE_QUIZ,
  ].includes(window.location.pathname as any);

  const shouldRedirect = configParams.bb === 'true';
  const shouldRedirectAndroid = configParams.bb_android === 'true';

  if (shouldRedirect && isMetaInAppBrowser && isRedirectAppRoute) {
    ShouldOpenInSystemBrowser();
  }
  if (shouldRedirectAndroid && isMetaInAppBrowser && isRedirectAppRoute) {
    ShouldOpenAndroidInSystemBrowser();
  }
};

const detectIOSVersion = (version: number) => {
  try {
    if (isBrowser) {
      const userAgent = navigator.userAgent || navigator.vendor;
      if (
        /iPad|iPhone|iPod|Macintosh|ios|Mac/i.test(userAgent) &&
        !(window as any).MSStream
      ) {
        let IOSVersion = (navigator.userAgent.match(
          /\b[0-9]+_[0-9]+(?:_[0-9]+)?\b/,
        ) || [''])[0].split('_')[0];
        return Number(IOSVersion) <= version;
      }
    }
    return false;
  } catch (e) {
    console.error('Could not detect IOS version');
    return false;
  }
};

const isIOS14Check = detectIOSVersion(14);
const isIOS15Check = detectIOSVersion(15);
const isIOS16Check = detectIOSVersion(16);
export const isIOS26Check = detectIOSVersion(26);

/**
 * Redirects from Facebook in-app browser to:
 * IOS <= 14 --> Safari browser;
 * IOS > 14 --> Chrome browser if it's installed;
 * Android --> Chrome browser;
 *
 * IOS greater than 14 doesn't support FTP URL's;
 * On the other hand Facebook in-app browser
 * doesn't support OAuth2 Google Sign-In;
 * That's why we need to
 * @constructor
 */
export function ShouldOpenInSystemBrowser(): void {
  if (isBrowser) {
    switch (getOS()) {
      case 'ios':
        if (isIOS14Check) {
          window.location.href =
            'ftp://files.devroqapps.com/redirect.html?url=' +
            encodeURIComponent(window.location.href);
        } else if (isIOS15Check) {
          break;
        } else if (isIOS16Check) {
          window.location.href =
            'googlechrome-x-callback://x-callback-url/open/?url=' +
            encodeURIComponent(window.location.href);
        } else {
          // const legacyScheme = `com-apple-mobilesafari-tab:${window.location.href}`;
          const xSafariScheme = `x-safari-${window.location.href}`;
          window.location.href = xSafariScheme;
        }
        break;
      case 'android':
        window.location.href =
          'https://browser.redirectnative.xyz/redirect.php?url=' +
          encodeURIComponent(window.location.href);

        break;
    }
  }
}

/**
 * Redirects from Facebook in-app browser to:
 * Android --> Chrome browser;
 *
 * The same as ShouldOpenInSystemBrowser but only for android
 * @constructor
 */
export function ShouldOpenAndroidInSystemBrowser(): void {
  if (isBrowser) {
    switch (getOS()) {
      case 'android':
        window.location.href =
          'https://browser.redirectnative.xyz/redirect.php?url=' +
          encodeURIComponent(window.location.href);

        break;
    }
  }
}
